import { getBreakpoints } from '../utils/utils';

(function ($) {
  const menu = '.hero-menu';
  const menuItemsOuter = '.hero-menu__items-outer';
  const menuItems = '.hero-menu__items';
  const menuLinks = '.hero-menu__link';
  const button = '.hero-menu__button';
  const buttonInner = '.hero-menu__button-inner';
  const collapse = '.hero-menu, .hero-menu__items-outer, .hero-menu__items, .hero-menu__item, .hero-menu__button, .hero-menu__button-inner';
  const header = '.header';
  const sidebarSticky = 'hero-menu--sticky';
  const sidebarStickyPoint = '.hero-menu__point';
  const pageSections = '.page-section';
  const heroSection = '.hero';
  const heroSectionHeight = $(heroSection).height();
  const breakPoint = getBreakpoints().md;
  let currentWindowWidth = $(window).width();

  function transformMenuToCollapse() {
    if ($(window).width() < breakPoint) {
      if (!$(menu).hasClass('collapse')) {
        $(collapse).addClass('collapse');
        $(button).attr('tabindex', 1);
      }
    } else {
      $(collapse).removeClass('collapse').removeAttr('style').removeClass('open');
      $(button).attr('tabindex', -1);
    }
  }

  $(window).on('load', () => {
    transformMenuToCollapse();
  });

  $(window).on('resize', () => {
    const width = $(window).width();
    if (currentWindowWidth !== width) {
      transformMenuToCollapse();
      currentWindowWidth = width;
    }
  });

  $(document).on('click', button, () => {
    $(buttonInner).toggleClass('open');
    $(menuItemsOuter).slideToggle().toggleClass('open');
  });

  function stickySidebar() {
    const offset = $(sidebarStickyPoint).offset().top;
    const headerHeight = $(header).height();
    const scrollTop = $(window).scrollTop();

    if (offset - headerHeight < scrollTop) {
      $(menu).addClass(sidebarSticky);
    } else {
      $(menu).removeClass(sidebarSticky);
    }
  }

  function stickySidebarInternational() {
    const offset = $(sidebarStickyPoint).offset().top;
    const scrollTop = $(window).scrollTop();

    if (offset < scrollTop) {
      $(menu).addClass(sidebarSticky);
    } else {
      $(menu).removeClass(sidebarSticky);
    }
  }

  function changeCurrentElementViaHash() {
    const currentPageHash = window.location.href;
    $(menuLinks).each((ind, el) => {
      if (el.href === currentPageHash && currentPageHash.length > 0) {
        $(menuLinks).removeClass('hero-menu__link--current');
        $(el).addClass('hero-menu__link--current');
      }
    });

    if (currentPageHash.length === 0) {
      $(menuLinks).first().addClass('hero-menu__link--current');
    }
  }

  function changeActiveLinkViaScroll() {
    const windowScroll = $(window).scrollTop();
    let current = '';

    if (windowScroll > heroSectionHeight) {
      $(pageSections).each((ind, section) => {
        const sectionTop = section.offsetTop - 200;
        if (window.scrollY >= sectionTop) { current = section.getAttribute('id'); }
      });

      $(menuLinks).each((ind, li) => {
        if (li.href.includes(`#${current}`) && current.length > 1) {
          $(li).closest(menuItems).find(menuLinks).removeClass('hero-menu__link--current');
          $(li).addClass('hero-menu__link--current');
        }
      });
    }
  }

  $(window).on('load', () => {
    if (!$(menu).length) {
      return;
    }

    // stickySidebar();
    changeCurrentElementViaHash();
  });

  $(document).on('click', (e) => {
    if (!$(menu).is(e.target) && $(menu).has(e.target).length === 0 && $(window).width() < breakPoint) {
      $(buttonInner).removeClass('open');
      $(menuItemsOuter).slideUp().removeClass('open');
    }
  });

  $(window).bind('scroll', () => {
    if (!$(menu).length) {
      return;
    }

    if ($(window).width() < breakPoint && $(buttonInner).hasClass('open')) {
      $(buttonInner).removeClass('open');
      $(menuItemsOuter).slideUp().removeClass('open');
    }

    // if ($(menu).hasClass('international')) {
    //   stickySidebarInternational();
    // } else {
    //   stickySidebar();
    // }

    changeActiveLinkViaScroll();
  });

  $(menuLinks).on('click', function (el) {
    if (el.target.target !== '_blank') {
      $(menuLinks).removeClass('hero-menu__link--current');
      $(this).addClass('hero-menu__link--current');
    }
  });

  window.addEventListener('beforeunload', () => {
    if ($(menu).length) {
      changeCurrentElementViaHash();
    }
  });
}(jQuery));
export default true;
